export default __webpack_public_path__ + "static/media/desapintar.2f38be2c.png";